// @flow

import type {DeviceType} from 'redux/middleware/googleTagManager/types';

// $FlowIgnore
import {isMobile, isTablet, osName} from 'react-device-detect';

import {
  DEVICE_TYPE_DESKTOP,
  DEVICE_TYPE_MOBILE,
  DEVICE_TYPE_TABLET,
} from 'redux/middleware/googleTagManager/types';

export const getDeviceType = (): DeviceType => {
  if (isTablet) {
    return DEVICE_TYPE_TABLET;
  }
  if (isMobile) {
    return DEVICE_TYPE_MOBILE;
  }
  // There are other device types too (smartv, wearable, ...).
  // Our tracking spec however only expects three.
  // So at this point we bunch the rest together as "desktop".
  return DEVICE_TYPE_DESKTOP;
};

export const getOperatingSystem = (): string => osName;
